export default __webpack_public_path__ + "static/tutorweb-1-c29560724a05b85d00fdefb10017360d.svg";